import * as LabelPrimitive from '@radix-ui/react-label'
import { cn } from '@shared/lib/cn'

export interface LabelProps extends React.ComponentPropsWithoutRef<typeof LabelPrimitive.Root> {
  required?: boolean
}

export function Label({ className, children, required, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root className={cn('typo-base text-secondary', className)} {...props}>
      {children}
      {required && <span className="typo-lg-strong text-red ml-0.5">*</span>}
    </LabelPrimitive.Root>
  )
}
